export default __webpack_public_path__ + "static/media/skype.43d4fffd.png";